import { StylesConfig } from 'react-select';

const fontStyles = {
  color: '#283244',
  fontSize: '16px',
};

export const helpSupportStyles: StylesConfig<any, false> = {
  control: (base: any, { isFocused, isDisabled }) => {
    let additionalStyles = {};

    if (isFocused) {
      additionalStyles = {
        borderColor: '216EF2',
        boxShadow: 'none',
      };
    }

    if (isDisabled) {
      additionalStyles = {
        background: '#f2f2f2',
      };
    }

    return {
      ...base,
      cursor: 'pointer',
      borderRadius: '8px',
      padding: '0 10px',
      border: '2px solid #dde4e9',
      fontWeight: '600',
      background: '#ffffff',
      minHeight: '30px',
      height: 'auto',
      paddingTop: '5px',
      paddingBottom: '5px',
      ...additionalStyles,
    };
  },
  valueContainer: (base: any) => ({ ...base, padding: '0' }),
  indicatorSeparator: () => ({ display: 'none' }),
  dropdownIndicator: (base: any) => ({
    ...base,
    color: '#283244',
    padding: 0,
  }),
  clearIndicator: (base: any) => ({
    ...base,
    color: '#283244',
    padding: 0,
  }),
  singleValue: (base: any) => ({
    ...base,
    ...fontStyles,
    paddingRight: '10px',
  }),
  input: (base: any) => ({
    ...base,
    padding: 0,
  }),
  placeholder: (base: any) => ({
    ...base,
    paddingRight: '10px',
    ...fontStyles,
  }),
  menu: (base: any) => ({
    ...base,
    borderRadius: '8px',
    zIndex: 2,
  }),
  menuList: (base: any) => ({
    ...base,
    padding: 0,
    borderRadius: '8px',
  }),
  option(base: any, props) {
    const { isFocused } = props;
    let additionalStyles = {};

    if (isFocused) {
      additionalStyles = {
        backgroundColor: '#216EF2',
        color: '#fff',
      };
    }

    return {
      ...base,
      ...fontStyles,
      'cursor': 'pointer',
      'backgroundColor': '#ffffff',

      '&:hover': {
        backgroundColor: '#216EF2',
      },
      ...additionalStyles,
    };
  },
};
